module.exports = __webpack_public_path__ + "static/img/9areaA_07.837595e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/9areaA_07.png
// module id = 821
// module chunks = 1